exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bookNavigation[data-v-67ecc724]{display:flex;justify-content:space-around;align-items:center;height:60px;max-height:60px;background-color:#eee;margin:auto}.bookNavigation .icon[data-v-67ecc724]{display:flex;height:2.3vw;max-height:30px;width:2.3vw;max-width:30px;padding:.25em;opacity:1;transition:opacity .25s ease-in-out}.bookNavigation .icon.visible[data-v-67ecc724]{cursor:pointer;width:100%}.bookNavigation .icon.visible[data-v-67ecc724]:hover{opacity:.7!important}.bookNavigation .icon[data-v-67ecc724]:focus{outline:none}.bookNavigation .icon.visible.outlined[data-v-67ecc724]:focus{outline:1px dashed currentColor}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67ecc724","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-book-component/components/bookNavigation/bookNavigation.vue
// module id = 18
// module chunks = 0